export default
{
  name: 'Foundation',
  fee: 700,
  value: 'foundation',
  fullname: 'Foundation for providers',
  floors: {
    1: 550,
    2: 450,
    3: 450,
    4: 450,
    5: 450,
    6: 400,
    7: 400,
    8: 375,
    9: 375,
    10: 375,
    11: 350,
    12: 350,
    13: 350,
    14: 350,
    15: 350,
    16: 350
  },
  annualFloors: {
    1: 5670,
    2: 4335,
    3: 4335,
    4: 4335,
    5: 4335,
    6: 3825,
    7: 3825,
    8: 3570,
    9: 3570,
    10: 3570,
    11: 3060,
    12: 3060,
    13: 3060,
    14: 3060,
    15: 3060,
    16: 3060
  }
}



// WEBPACK FOOTER //
// ./src/data/solutionfees.js